import { productConstants } from "../constants";
import { productService } from "../../services";

export const productActions = {
  addProduct,
  getProductsList,
  getProductsSort,
  editProduct,
  getProduct,
  saveVariant,
};

function getProductsSort({ pageID, perPage, searchInput = "", sort = "" }) {
  return (dispatch) => {
    dispatch(request());
    return productService
      .productsListResponse(pageID, perPage, searchInput, sort)
      .then(
        ({ data }) => {
          const { body } = data;
          dispatch(
            success(body.products, body.data.total, body.data.last_page)
          );
        },
        (error) => {
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: productConstants.GETALL_REQUEST };
  }
  function success(items, total, last_page) {
    return { type: productConstants.GETALL_SUCCESS, items, total, last_page };
  }
  function failure(error) {
    return { type: productConstants.GETALL_FAILURE, error };
  }
}

function getProductsList(pageID, perPage, searchInput = "") {
  return (dispatch) => {
    dispatch(request());
    return productService
      .productsListResponse(pageID, perPage, searchInput)
      .then(
        (response) => {
          dispatch(
            success(
              response.data.body.products,
              response.data.body.data.total,
              response.data.body.data.last_page
            )
          );
        },
        (error) => {
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: productConstants.GETALL_REQUEST };
  }
  function success(items, total, last_page) {
    return { type: productConstants.GETALL_SUCCESS, items, total, last_page };
  }
  function failure(error) {
    return { type: productConstants.GETALL_FAILURE, error };
  }
}

function _deleteVariant(veriantID) {
  return productService._deleteVariantRequest(veriantID).then(
    (response) => {
      return "sucesss";
    },
    (error) => {
      return error;
    }
  );
}

function addProduct(addToast, formData) {
  return (dispatch) => {
    dispatch(request());
    return productService.addProductRequest(formData).then(
      (response) => {
        formData.variants.map((variant, index) => {
          let result = _addVariant(variant, response.data.body.id);
          if (result !== 1) dispatch(failure(result));
        });
        addToast("محصول با موفقیت منتشر شد.", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(success(response.data.status));
      },
      (error) => {
        if (typeof error === "object") {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: "error", autoDismiss: true });
          });
        } else {
          addToast("خطا در برقراری اتصال با سرور!", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: productConstants.ADD_REQUEST };
  }
  function success(response) {
    return { type: productConstants.ADD_SUCCESS, response };
  }
  function failure(error) {
    return { type: productConstants.ADD_FAILURE, error };
  }
}

function editProduct(addToast, formData) {
  // console.log(formData);
  return (dispatch) => {
    dispatch(request());
    return productService.editProductRequest(formData).then(
      (response) => {
        formData.deleted_variants.map((veriantID) => {
          const result = _deleteVariant(parseInt(veriantID));
          if (result !== "success") dispatch(failure(result));
        });

        addToast("تغییرات با موفقیت ثبت شد.", {
          appearance: "success",
          autoDismiss: true,
        });

        setTimeout(() => {
          dispatch(success(response));
        }, 4000);
      },
      (error) => {
        if (typeof error === "object") {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: "error", autoDismiss: true });
          });
        } else {
          addToast("خطا در برقراری اتصال با سرور!", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: productConstants.EDIT_REQUEST };
  }
  function success(response) {
    return { type: productConstants.EDIT_SUCCESS, response };
  }
  function failure(error) {
    return { type: productConstants.EDIT_FAILURE, error };
  }
}

function saveVariant(addToast, variant, productID) {
  return () => {
    const request = variant.isSaved
      ? productService._editVariantRequest(variant, productID)
      : productService._addVariantRequest(variant, productID);

    return request.then(
      (response) => {
        addToast(variant.isSaved ? "ویژگی بروزرسانی شد." : "ویژگی ایجاد شد.", {
          appearance: "success",
          autoDismiss: true,
        });
        return response;
      },
      (error) => {
        if (typeof error === "object" && error) {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: "error", autoDismiss: true });
          });
        } else {
          addToast("خطا در برقراری اتصال با سرور!", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        return Promise.reject(error);
      }
    );
  };
}

function _addVariant(variant, productID) {
  return productService._addVariantRequest(variant, productID).then(
    (response) => {
      return "sucesss";
    },
    (error) => {
      return error;
    }
  );
}

function getProduct(productID) {
  return (dispatch) => {
    dispatch(request());
    return productService.getProductResponse(productID).then(
      (response) => {
        dispatch(success(response.data.body));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: productConstants.GET_REQUEST };
  }
  function success(item) {
    return { type: productConstants.GET_SUCCESS, item };
  }
  function failure(error) {
    return { type: productConstants.GET_FAILURE, error };
  }
}
